<template>
  <v-select
      v-model="model"
      label="Motortyp"
      :items="items"
      item-title=key
      :prepend-icon="props.prepend_icon"
      :variant="useGlobalSetting().globalTextVariant"
  >
    <template v-slot:item="{ props: itemProps, item }">
      <v-list-item
          v-bind="itemProps"
          :subtitle="item.raw.description"
      ></v-list-item>
    </template>
  </v-select>
</template>

<script setup lang="ts">

import {useGlobalSetting} from "@/lib/utils";

const model = defineModel();

const props = defineProps({
  prepend_icon: {
    type: String,
    default: '',
    required: false,
  },
})

const items = [
  {
    key: "M1S",
    description: "Basis-Motorstarter für kleine bis mittlere Motoren"
  },
  {
    key: "M1S_FB",
    description: "Rückmeldungseinheit für Motorstarter M1S"
  },
  {
    key: "MMD",
    description: "Motor Management Device – zentrale Steuereinheit für Motorfunktionen"
  },
  {
    key: "MMD_HP",
    description: "Motor Management Device mit Hochleistungsfunktionen"
  },
  {
    key: "MMD_P",
    description: "Motor Management Device mit Prozessanbindung"
  },
  {
    key: "MRE",
    description: "Relaisbasierter Motorstarter"
  },
  {
    key: "MRE_FB",
    description: "Rückmeldungseinheit für Motorregelungseinheit MRE"
  },
  {
    key: "MSD",
    description: "Siemens Starter Device – Standard-Motorstarter"
  },
  {
    key: "MSD_FB",
    description: "Rückmeldungseinheit für MSD"
  },
  {
    key: "MSD_PF",
    description: "MSD mit Power Feedback – Leistungsrückmeldung integriert"
  },
  {
    key: "MSS",
    description: "Siemens Soft Starter – für sanftes Hochfahren von Motoren"
  },
  {
    key: "PF",
    description: "Power Feedback – Modul zur Leistungsrückmeldung"
  }
]

</script>